import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const PerformanceImprovementAndCostOptimisation = () => {
  const serviceData = {
    title: "Performance Improvement & Cost Optimisation",
    heading: "Performance Improvement & Cost Optimisation",
    image: subTopicImages["Performance Improvement & Cost Optimization"],
    intro: "",
    description: [
      "We help improve profitability through structured financial discipline and operational efficiency, including cost-to-serve analysis, working capital management, pricing insights, MIS dashboards and cash-flow visibility programs — focusing on sustainable improvement rather than short-term cuts.",
    ],
    services: [],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };
  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default PerformanceImprovementAndCostOptimisation;
